import { WidgetHeader } from 'legacy/lut/components/widgets/public/partner360/widgetHeader/WidgetHeader'

import { Translation } from 'cng-common/features/translations/components/translation'
import { Button } from 'core-components/library/button'

import styles from './ConfirmNotApplicableDialogContent.module.scss'

interface IProps {
  category: string
  onConfirm: () => void
  onClose: () => void
}

export const ConfirmNotApplicableDialogContent = ({ category, onConfirm, onClose }: IProps) => {
  return (
    <div className={styles.root}>
      <WidgetHeader>jbp-not-applicable-confirm-title</WidgetHeader>
      <p>
        <Translation
          text="jbp-not-applicable-confirm-info"
          replaceParams={[
            {
              key: '{category}',
              value: category,
            },
          ]}
        />
      </p>
      <div className={styles.btns}>
        <Button className={styles.btns__btn} onClick={onConfirm}>
          <Translation text="jbp-not-applicable-confirm-apply" />
        </Button>
        <Button color="grey" onClick={onClose}>
          <Translation text="jbp-not-applicable-confirm-cancel" />
        </Button>
      </div>
    </div>
  )
}
